<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="factor" v-model="filter.factor" :label="label.factor" item-text="label" item-value="value" :error-messages="errors.collect('filter.factor')" data-vv-name="filter.factor" :data-vv-as="label.factor" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filter.desc" :label="label.desc" :error-messages="errors.collect('desc')" data-vv-name="desc" :data-vv-as="label.desc"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" color="primary" @click.native="doPrint">
            <span>Print</span>
            <v-icon right dark>mdi-printer</v-icon>
          </v-btn>
          <v-btn color="primary" @click.native="doNew" v-if="checkAccess(['ROLE_SUPERADMIN'])">
            New Risk Factor<v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.factor }} </td>
                <td class="text-xs-left">{{ row.item.desc }} </td>
                <td class="text-xs-left">{{ row.item.allLookUp }} </td>
                <td class="text-xs-left">{{ row.item.isStatistic }} </td>
                <td class="text-xs-left">{{ row.item.isNum }} </td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" :review="checkAccess(['ROLE_SUPERADMIN'])" @review="doReview(row.item)" :remove="checkAccess(['ROLE_SUPERADMIN'])" @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
        <confirm v-model="promptRemove" @ok="doDelete">
          <p>Are you sure you want to delete the Risk Factor?</p>
          <div class="queryValue">Factor: {{selectedRiskFact.factor}}<br/>
          </div>
      </confirm>
      </v-card>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { extractMenu } from '@/utils/extract'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      toogleArray: [false],
      submitting: false,
      factor: [],
      label: {
        factor: 'Factor',
        desc: 'Description'
      },
      filter: {
        factor: null,
        desc: null
      },
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Factor', align: 'left', value: 'factor' },
        { text: 'Description', align: 'left', value: 'desc' },
        { text: 'Allow Lookup', align: 'left', value: 'allLookUp' },
        { text: 'Is Statistics', align: 'left', value: 'isStatistic' },
        { text: 'Is Number', align: 'left', value: 'isNum' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedRiskFact: {
        factor: null
      },
      riskFactMenuLink: {},
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('paramReportsInit')])

      this.getCommonDataListDropDown('factor')
      this.fetchData(true)
      this.getRiskFactMenuLink()
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.riskFactList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let messageFilters = clone(this.filter)

          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((riskFact) => {
                const convertList = {
                  factor: riskFact.factor,
                  desc: riskFact.desc,
                  allLookUp: riskFact.allLookUp,
                  isStatistic: riskFact.isStatistic,
                  isNum: riskFact.isNum
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.factor = null
      this.filter.desc = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      const commit = {
        riskFactMode: 'New',
        factor: null
      }
      sessionStorage.setItem('riskFact', JSON.stringify(commit))
      this.$store.commit('RISK_FACTOR_COMMIT_KEY', commit)
      this.$router.push({ name: 'riskFactorDetail' })
    },
    doReview(data) {
      const commit = {
        riskFactMode: 'Review',
        factor: data.factor
      }
      sessionStorage.setItem('riskFact', JSON.stringify(commit))
      this.$store.commit('RISK_FACTOR_COMMIT_KEY', commit)
      this.$router.push({ name: 'riskFactorDetail' })
    },
    doQuery(data) {
      const commit = {
        riskFactMode: 'Query',
        factor: data.factor
      }
      sessionStorage.setItem('riskFact', JSON.stringify(commit))
      this.$store.commit('RISK_FACTOR_COMMIT_KEY', commit)
      this.$router.push({ name: 'riskFactorDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteRiskFact
          const expand = {
            factor: data.factor
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedRiskFact.factor = data.factor
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedRiskFact) {
        const apiURI = this.menu.deleteRiskFact
        if (apiURI) {
          const expand = {
            factor: this.selectedRiskFact.factor
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    async doPrint() {
      this.doExportRiskFactRecord()
    },
    async getRiskFactMenuLink() {
      try {
        const apiURI = this.riskFactReportMenu.riskFact
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.riskFactMenuLink = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doExportRiskFactRecord() {
      const apiURI = this.riskFactMenuLink.exportRiskFactRecord
      let messageFilters = clone(this.filter)
      if (apiURI) {
        this.$http
          .post(apiURI, messageFilters)
          .then((result) => {})
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      } else {
        this.$toast.error('An error encountered unable to Risk Factor record.')
      }
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  computed: {
    menu() {
      return this.$store.state.riskFactorParam.menu
    },
    riskFactReportMenu() {
      return this.$store.state.reports.paramReports.menu
    },
    ...mapGetters(['checkAccess'])
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
